import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath, useToggleRevealItem } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'tabs',
  element: 'tab'
});
export var TabButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'button' : _ref$as,
      children = _ref.children,
      id = _ref.id,
      open = _ref.open,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ["as", "children", "id", "open", "onOpen", "onClose"]);

  var _useToggleRevealItem = useToggleRevealItem({
    open: open,
    id: id,
    onOpen: onOpen,
    onClose: onClose
  }),
      extToggleOpen = _useToggleRevealItem.extToggleOpen,
      isOpen = _useToggleRevealItem.isOpen;

  var activeStyle = isOpen ? {
    variant: variantPath('active')
  } : {
    variant: variantPath('base'),
    '&:hover, ._force-hover &': {
      variant: variantPath('base', 'hover')
    },
    '&:focus, ._force-focus &': {
      variant: variantPath('base', 'focus')
    }
  };
  var activeProps = isOpen ? {} : {
    onClick: function onClick(e) {
      extToggleOpen();
    }
  };
  return _jsxs(As, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    sx: _objectSpread({}, activeStyle),
    disabled: isOpen
  }, activeProps), props), {}, {
    children: [_jsx("span", {
      sx: {
        display: 'inline-block',
        height: '24px'
      }
    }), children]
  }));
});
TabButton.propTypes = {
  /**
   * The initial state for the item
   */
  open: PropTypes.bool,

  /**
   * The id of the item, by default this is the index. It can be overriden with your own id numbers.
   */
  id: PropTypes.number,

  /**
   * Callback functions that get executed when the item is either open or closed
   */
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};